import { useContext } from 'react'

import AuthContext from '../context/AuthContext'

type TAuth = {
  isLoggedIn: boolean
  hasExpired: boolean
  membership: {
    id: string | null
    owner: string | null
    user: {
      id: string | null
      accountType: string | null
      status: string | null
      email: string
      firstName: string
      lastName: string
      createdAt: string | null
      updatedAt: string | null
      imageUrl: string | null
    }
    dealer: {
      id: string | null
      name: string
      type?: string | null
      credit?: {
        balance: number
        baseCost: number
        dtcCreditCostOverride?: number | null
      }
      address: {
        id: string | null
        status: string | null
        line1: string
        line2: string
        city: string
        region: string
        postcode: string
        country: string | null
        createdAt: string | null
        updatedAt: string | null
      }
      terms: {
        acceptedBy: string | null
        acceptedAt: string | null
        acceptedIP: string | null
        acceptedVersion: string | null
        requiresAcceptance: boolean | null
      }
      tgtNumber: number | null
      logoKey: string | null
    }
  }
}

type TSetAuth = (value: TAuth) => void

type TAuthContextValue = [TAuth, TSetAuth]

const useAuth = () => {
  return useContext(AuthContext) as unknown as TAuthContextValue
}

export type { TAuth, TAuthContextValue }

export default useAuth
